import { render, staticRenderFns } from "./PlanPlace.vue?vue&type=template&id=f48b59c4&scoped=true&"
import script from "./PlanPlace.vue?vue&type=script&lang=js&"
export * from "./PlanPlace.vue?vue&type=script&lang=js&"
import style0 from "./PlanPlace.vue?vue&type=style&index=0&id=f48b59c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48b59c4",
  null
  
)

export default component.exports